/**
 * useClearPipeBlocked — PM-only mutation that POSTs to
 * /api/admin/assets/{id}/clear-pipe-blocked. Closes CP2 (asymmetric
 * pipe-blocked rule) end-to-end: pipe_blocked is set by worker observation
 * but cleared only by PM (jetting happens out-of-band).
 *
 * On success, invalidates ASSETS_GEOJSON_KEY so the pipe-blocked dimension
 * chip recolors that asset on the map.
 *
 * Server endpoint (Plan 04-01 admin/clear_pipe_blocked_router):
 *   - 200 { code: "OK_PIPE_BLOCKED_CLEARED", asset_id }
 *   - 404 ERR_ASSET_NOT_FOUND
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost, ApiError } from "../../api/client";
import { ASSETS_GEOJSON_KEY } from "../../api/assets";
import type { ClearPipeBlockedResponse } from "../../api/inspections";

interface ClearPipeBlockedVars {
  assetId: number;
}

export function useClearPipeBlocked() {
  const qc = useQueryClient();
  return useMutation<ClearPipeBlockedResponse, ApiError, ClearPipeBlockedVars>({
    mutationFn: ({ assetId }) =>
      apiPost<ClearPipeBlockedResponse>(
        `/api/admin/assets/${assetId}/clear-pipe-blocked`,
        {},
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ASSETS_GEOJSON_KEY });
    },
  });
}
